// extracted by mini-css-extract-plugin
module.exports = {"scrollBarHidden":"notification_scrollBarHidden_3BNKY","optionsDropdown":"notification_optionsDropdown_1B8F-"};